module.exports = __webpack_public_path__ + "static/media/IMG_6030.1ab22c36.JPG";